import React from "react";
import Switch from "../ui/Switch";
import PortalQuoteSettingStatus from "./PortalQuoteSettingStatus";
import { currencyList } from "../../data/currencyList";

const PortalQuoteSettings = ({ showMovida, currency, disabled, onChange, savingSetting }) => (
    <div className="portal-quote-settings">
        <label className="portal-quote-settings__field">
            <span>MOVIDA</span>
            <Switch
                controlled
                isOn={!!showMovida}
                disabled={disabled}
                value={(value) => onChange({ Show_MOVIDA_in_Quote: value })}
                classNames={["switch--gold", "switch--small"]}
                ariaLabel="Show MOVIDA in quote"
            />
            {savingSetting === "movida" && <PortalQuoteSettingStatus />}
        </label>
        <label className="portal-quote-settings__field">
            <span>Preferred Currency</span>
            <select
                aria-label="Preferred Currency"
                value={String(currency || "").toLowerCase()}
                disabled={disabled}
                onChange={(event) => onChange({ Preferred_Currency: event.target.value })}
            >
                <option value="" disabled>
                    Select currency
                </option>
                {currencyList.map(({ value, label }) => (
                    <option key={value} value={value}>
                        {label}
                    </option>
                ))}
            </select>
            {savingSetting === "currency" && <PortalQuoteSettingStatus />}
        </label>
    </div>
);

export default PortalQuoteSettings;
